
import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import UserManagement from "@/components/admin/UserManagement";
import SystemAnalytics from "@/components/admin/SystemAnalytics";
import SystemSettings from "@/components/admin/SystemSettings";

const Admin = () => {
  const { toast } = useToast();
  const { hasPermission } = useAuth();

  return (
    <div className="container mx-auto py-6">
      <h1 className="text-3xl font-bold mb-6 dark:text-white">Admin Dashboard</h1>

      <Tabs defaultValue="users" className="space-y-4">
        <TabsList>
          {hasPermission('manage_users') && (
            <TabsTrigger value="users">User Management</TabsTrigger>
          )}
          {hasPermission('access_analytics') && (
            <TabsTrigger value="analytics">Analytics</TabsTrigger>
          )}
          {hasPermission('manage_system_settings') && (
            <TabsTrigger value="settings">System Settings</TabsTrigger>
          )}
        </TabsList>

        {hasPermission('manage_users') && (
          <TabsContent value="users" className="space-y-4">
            <UserManagement />
          </TabsContent>
        )}

        {hasPermission('access_analytics') && (
          <TabsContent value="analytics">
            <SystemAnalytics />
          </TabsContent>
        )}

        {hasPermission('manage_system_settings') && (
          <TabsContent value="settings">
            <SystemSettings />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
};

export default Admin;
